import { faAngleDown, faCircleNodes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import { IClusterInfo } from "../../../../model/CarbonExternalModels";
import { selectConstellations, useCarbonSelector } from "../../../../store/carbonStore";
import { Button } from "userful-chronos-common-ui/dist";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";

interface IProps {
    clusterID: StringID;
    handleClick(clusterID: StringID): void;
}

export default function ClustersDropdownSelector({ clusterID, handleClick }: IProps) {
    const constellations = useCarbonSelector(selectConstellations);
    const allClusters: IClusterInfo[] = [];

    for (const property in constellations) {
        for (let i = 0; i < constellations[property].cluster.length; i++) {
            if (constellations[property].cluster[i].name !== "N/A") {
                allClusters.push(constellations[property].cluster[i]);
            }
        }
    }

    const cluster = allClusters.find((c) => c.id.value === clusterID.value);

    return (
        <Dropdown className="dropdown-input">
            <Dropdown.Toggle as={Button}>
                <div className="textInside">{cluster ? cluster.name : "Select a cluster..."}</div>
                <FontAwesomeIcon icon={faAngleDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="userful-icon-dropdown-menu"
                popperConfig={{ strategy: "fixed" }}
                renderOnMount={true}
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
            >
                {allClusters.length > 0 && (
                    <>
                        {allClusters.map((c) => {
                            if (c.status === "CONNECTED") {
                                return (
                                    <Dropdown.Item
                                        key={c.id.value}
                                        onClick={() => {
                                            handleClick(c.id);
                                        }}
                                    >
                                        <div className="gcm-icon-dropdown-menu-icon-container">
                                            <FontAwesomeIcon className="blue" icon={faCircleNodes} />
                                        </div>
                                        <p>{c.name}</p>
                                    </Dropdown.Item>
                                );
                            }
                        })}
                    </>
                )}
                {allClusters.length === 0 && (
                    <Dropdown.Item disabled>
                        <div className="gcm-icon-dropdown-menu-icon-container">
                            <FontAwesomeIcon icon={faCircleNodes} />
                        </div>
                        <p>No clusters available...</p>
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}
